exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hearder[data-v-d772e614] {height: 44px; width: 100%; background: #3af; display: -webkit-box; display: -ms-flexbox; display: flex; padding: 0 12px; -webkit-box-sizing: border-box; box-sizing: border-box;\n}\n", ""]);

// exports
